module.exports = "<div class=\"time-wrp js-time-region\"></div> <div class=svg-icons-wrp> <div class=svg-icons-wrp__empty> <svg class=\"svg-icons svg-icons_time\"><use xlink:href=#icon-time /></svg> </div> <div class=\"js-clear-button svg-icons-wrp__remove\"> <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=#icon-remove /></svg> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/timeEditor.hbs
// module id = 696
// module chunks = 0